import anaConsts from 'analytics/constants';
import analyticsUtils from 'analytics/utils';
import processEvent from 'analytics/processEvent';

const {
    LINK_TRACKING_EVENT,
    PAGE_LOAD,
    PAGE_TYPES: { USER_PROFILE },
    PAGE_NAMES: { BI_SIGNED_IN, BI_ANONYMOUS, MY_BEAUTY_INSIDER, BEAUTY_INSIDER },
    NAV_PATH: { TOP_NAV, ACCOUNT }
} = anaConsts;

const ACTIVE_TAB_PARAM = 'activeTab';
const ACTIVE_TAB_TO_WORLD_MAP = {
    EarnPoints: 'earn points',
    History: 'history',
    Benefits: 'benefits'
};

function getWorldFromActiveTab() {
    if (typeof window === 'undefined') {
        return null;
    }

    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    const activeTab = hashParams.get(ACTIVE_TAB_PARAM);

    return ACTIVE_TAB_TO_WORLD_MAP[activeTab] || null;
}

function setPageLoadAnalytics(isUserAtleastRecognized) {
    digitalData.page.category.pageType = USER_PROFILE;
    digitalData.page.pageInfo.pageName = isUserAtleastRecognized ? BI_SIGNED_IN : BI_ANONYMOUS;
}

function setPageLoadAnalyticsHub() {
    digitalData.page.category.pageType = USER_PROFILE;
    digitalData.page.pageInfo.pageName = MY_BEAUTY_INSIDER;

    const world = getWorldFromActiveTab();

    if (world) {
        digitalData.page.attributes.world = world;
    }
}

function setPageLoadAnalyticsAsyncHub(tabKey) {
    // Set page type and page name
    digitalData.page.category.pageType = USER_PROFILE;
    digitalData.page.pageInfo.pageName = MY_BEAUTY_INSIDER;

    // Set world based on tab key
    const world = ACTIVE_TAB_TO_WORLD_MAP[tabKey];

    if (world) {
        digitalData.page.attributes.world = world;
    } else {
        // For Rewards tab (default), clear world and additionalPageInfo
        digitalData.page.attributes.world = '';
    }

    analyticsUtils.setNextPageData({
        navigationInfo: ''
    });

    // Fire the page load event
    processEvent.process(PAGE_LOAD, {
        pageType: USER_PROFILE
    });
}

function setNextPageLoadAnalyticsData(...args) {
    const navigationInfo = analyticsUtils.buildNavPath([...args]);
    analyticsUtils.setNextPageData({ navigationInfo });
}

function setFlyoutNextPage() {
    setNextPageLoadAnalyticsData(TOP_NAV, ACCOUNT, BEAUTY_INSIDER, BEAUTY_INSIDER, BEAUTY_INSIDER);
}

function fireLinkTracking(actionInfo) {
    processEvent.process(LINK_TRACKING_EVENT, {
        data: {
            actionInfo
        }
    });
}

function getLocationType(record) {
    if (record?.groupType === 'NON_ORDER') {
        return 'other';
    }

    const groupDescLower = (record?.groupDescription || '').toLowerCase();

    // Treat records with a digitalOrderId or a Sephora.com group description as online purchases
    if (record?.digitalOrderId || groupDescLower.includes('sephora.com')) {
        return 'online';
    }

    // Default to store for in-store purchases
    return 'store';
}

function getActivityType(record) {
    // Check order status first
    const orderStatusCode = (record?.orderStatusCode || '').toLowerCase();

    if (orderStatusCode === 'canceled') {
        return 'cancelled';
    }

    if (orderStatusCode === 'returned') {
        return 'returned';
    }

    // Determine based on points
    if (record?.netGroupPoints > 0) {
        return 'earn';
    }

    return 'burn';
}

function firePointsActivityExpandAnalytics(record) {
    const locationType = getLocationType(record);
    const activityType = getActivityType(record);

    const actionInfo = `points activity:${locationType}:${activityType}`;

    processEvent.process(LINK_TRACKING_EVENT, {
        data: {
            actionInfo //prop55
        }
    });
}

export default {
    setPageLoadAnalytics,
    setPageLoadAnalyticsHub,
    setPageLoadAnalyticsAsyncHub,
    setFlyoutNextPage,
    fireLinkTracking,
    firePointsActivityExpandAnalytics
};
